import { useCallback } from 'react';
export const useOnChange = ({ onSearch, setValue, mask, value: previousValue, }) => {
    const onChange = useCallback((event) => {
        const value = mask ? mask(event.target.value, previousValue) : event.target.value;
        setValue(value);
        onSearch && onSearch(event.target.value);
    }, [setValue, onSearch, mask, previousValue]);
    return onChange;
};
